export enum ListSorting {
  Asc = "ascend",
  Desc = "descend",
}

export const APIListSortingMap = {
  [ListSorting.Asc]: "asc",
  [ListSorting.Desc]: "desc",
};
